export default function Hero() {
  return (
    <section className="relative w-full bg-gray-900 pt-36 pb-20 flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900/40"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-teal-400/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-teal-500/10 rounded-full blur-2xl"></div>
      <div className="relative z-10 text-center w-full px-4">
        <h1 className="text-6xl md:text-7xl font-extrabold text-white mb-5 tracking-tight leading-tight">
          Get In Touch
        </h1>
        <p className="text-xl md:text-2xl text-white/70 font-light max-w-xl mx-auto">
          Share the details of your event with us and we&apos;ll respond within 24 hours
        </p>
      </div>
    </section>
  );
}
